import { useState } from "react";
import type { FormEvent } from "react";
import { useQueryClient } from "@tanstack/react-query";
import "./force-password-change.css";

type Props = { name: string; email: string };

function detail(body: unknown) {
  if (body && typeof body === "object" && "detail" in body) return String((body as { detail?: unknown }).detail || "");
  return "";
}

export function ForcePasswordChange({ name, email }: Props) {
  const queryClient = useQueryClient();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    if (password.length < 8) { setError("Nowe hasło musi mieć minimum 8 znaków."); return; }
    if (password !== confirmPassword) { setError("Hasła nie są takie same."); return; }
    setBusy(true);
    try {
      const response = await fetch("/api/auth/change-password", {
        method: "POST", credentials: "include",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ password, confirmPassword }),
      });
      const body = await response.json().catch(() => null);
      if (!response.ok) throw new Error(detail(body) || `HTTP ${response.status}`);
      await queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
      await queryClient.refetchQueries({ queryKey: ["auth", "me"] });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Nie udało się zmienić hasła.");
    } finally { setBusy(false); }
  }

  return (
    <main className="force-password-screen">
      <form className="force-password-card" onSubmit={submit}>
        <span className="auth-kicker">PIERWSZE LOGOWANIE</span>
        <h1>Ustaw własne hasło</h1>
        <p>Hasło tymczasowe zadziałało. Zanim wejdziesz do aplikacji, ustaw własne hasło dla konta <strong>{name || email}</strong>.</p>
        <label><span>Nowe hasło</span><input autoFocus autoComplete="new-password" type="password" minLength={8} value={password} onChange={(event) => setPassword(event.target.value)} /></label>
        <label><span>Powtórz hasło</span><input autoComplete="new-password" type="password" minLength={8} value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} /></label>
        {error ? <div className="force-password-error">{error}</div> : null}
        <button className="primary-button" type="submit" disabled={busy}>{busy ? "Zapisuję…" : "Ustaw hasło i przejdź dalej"}</button>
        <small>Minimum 8 znaków. Po zmianie wszystkie wcześniejsze sesje tego konta zostaną unieważnione.</small>
      </form>
    </main>
  );
}
